import {useTranslation} from 'react-i18next';
import {StyledCardWithPadding} from '../../common/styled/StyledCard';
import {useGGContext} from 'src/components/providers/googleAds';
import {FormInputText} from '../../common/forms/inputs/FormInputText';
import {FormProvider, useForm} from 'react-hook-form';
import FormInputSelect from '../../common/forms/inputs/FormInputSelect';
import {FormHeader} from '../../common/forms/FormHeader';
import {FlexBoxColumn} from '../../common/FlexBoxColumn';
import {StyledFormLabel} from '../../common/forms/FormLabel';
import {yupResolver} from '@hookform/resolvers/yup';
import {useManageCategories} from './useManageCategories';
import {useSubmitForm} from './useSubmitForm';
import {memo} from 'react';
import {StyledRowStack} from 'src/components/common/styled/StyledRowStack';
import {FormStepsNextButton} from 'src/components/common/styled/FormStepsNextButton';
import * as Yup from 'yup';
import {ITranslation} from 'src/types/common/Translation';

const getValidationSchema = ({t}: ITranslation) => Yup.object().shape({
  businessName: Yup.string().required(t('errors.required')),
  categoryId: Yup.string().optional(),
  subcategoryId: Yup.string().optional()
});

export const FormStepTwo = memo(function FormStepTwo (): JSX.Element {
  const {t} = useTranslation(['common']);
  const context = useGGContext();

  const methods = useForm({
    defaultValues: {
      businessName: context.businessDetails.businessName ?? '',
      categoryId: context.businessDetails.categoryId?.toString() ?? '',
      subcategoryId: context.businessDetails.subcategoryId?.toString() ?? '',
    },
    mode: 'onChange',
    resolver: yupResolver(getValidationSchema({t}))
  });

  const {categories, subCategories, onCategoryChange} = useManageCategories(context);
  const {disabled, onSubmit} = useSubmitForm(methods.getValues);

  return (
    <FormProvider {...methods}>
      <form>
        <FlexBoxColumn>
          <StyledCardWithPadding sx={{gap: 3}}>
            <FormHeader step={context.currentStep} />
            <FlexBoxColumn sx={{width: '100%', gap: 2.5}}>
              <FlexBoxColumn sx={{width: '100%', gap: 1}}>
                <StyledFormLabel error={!!methods.formState.errors.businessName}>
                  {t('formSteps.step2.businessName')}
                </StyledFormLabel>
                <FormInputText data-testid="businessName" name={'businessName'} />
              </FlexBoxColumn>
              <FlexBoxColumn sx={{width: '100%', gap: 1}}>
                <StyledFormLabel>{t('formSteps.step2.category')}</StyledFormLabel>
                <FormInputSelect testid='categorySelect' name='categoryId' options={categories} changeHandler={onCategoryChange} />
              </FlexBoxColumn>
              <FlexBoxColumn sx={{width: '100%', gap: 1}}>
                <StyledFormLabel>{t('formSteps.step2.subCategory')}</StyledFormLabel>
                <FormInputSelect testid='subcategorySelect' name='subcategoryId' options={subCategories} />
              </FlexBoxColumn>
            </FlexBoxColumn>
            <StyledRowStack sx={{justifyContent: 'center'}}>
              <FormStepsNextButton onSubmit={onSubmit} disabled={disabled} id="google-business-info-next" />
            </StyledRowStack>
          </StyledCardWithPadding>
        </FlexBoxColumn>
      </form>
    </FormProvider>
  );
});
